export default function getCurrentLang() {
  const rawLang = localStorage.getItem("kitoLang") || navigator.language;
  return rawLang.split("-")[0].toLowerCase();
}
